import { useEffect, useState } from 'react'

import {
  getIsPaidUser,
  getUserFreeMembership,
} from '../../../shared/utils/get-user-session-permissions'

type UserState = 'anonymous' | 'payingOrFreeMember'

export const useFreeMembershipState = () => {
  const [userState, setUserState] = useState<UserState>('anonymous')
  const [displayLocking, setDisplayLocking] = useState(false)

  const [notABot, setNotABot] = useState(false)

  useEffect(() => {
    setNotABot(!/bot|crawl|spider/i.test(navigator.userAgent))

    if (getIsPaidUser(document.cookie) || getUserFreeMembership(document.cookie)) {
      setUserState('payingOrFreeMember')
      setDisplayLocking(false)
    } else {
      setUserState('anonymous')
      setDisplayLocking(true)
    }
  }, [])

  return {
    userState,
    displayLocking: displayLocking && notABot,
  }
}
